















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SaveShixinQuestionResult$ } from "@/request/shezhenjiaoxue";
import * as _ from "lodash";
import PicView from "@/components/pic-preview.vue";
@Component({
  components: {
    PicView,
  },
})
export default class SzsxDuoxuan extends Vue {
  @Prop()
  private question;
  @Prop()
  private index;
  @Prop()
  private len;
  private selectedValue: any[] = [];
  private ifShowPic: boolean = false;
  private ifShowAnswer: boolean = false;
  private index2Alpha: any[] = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
  ];
  @Watch("index", { immediate: true })
  private indexChange() {
    this.ifShowAnswer = false;
    this.selectedValue = [];
  }
  /**
   * @description 记录学习结果
   */
  private saveQuestionStudy() {
    const params: any = {
      question_id: this.question["question_id"],
      reply: this.selectedValue,
    };
    SaveShixinQuestionResult$(this, params).then((data: any) => {
      console.log(data);
    });
  }
  /**
   * @description 上一题
   */
  private prev() {
    if (this.selectedValue.length > 0) {
      this.saveQuestionStudy();
    }
    this.$emit("prev");
  }
  /**
   * @description 下一题
   */
  private next() {
    if (this.selectedValue.length > 0) {
      this.saveQuestionStudy();
    }
    this.$emit("next");
  }
  /**
   * @description 选择一项
   */
  private selectThis(o) {
    this.selectedValue.push(o);
    this.selectedValue = _.uniq(this.selectedValue);
  }
  /**
   * @description 展示答案
   */
  private showAnswer() {
    this.ifShowAnswer = true;
  }
  /**
   * @description 判断是否被选中
   */
  private ifSelected(oi) {
    const inx = this.selectedValue.indexOf(oi);
    if (inx !== -1) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description 判断是否答对
   */
  private ifCorrect(oi) {
    if (this.question["正确答案"].indexOf(oi) !== -1) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description 没有选择但是答案在正确答案里
   */
  private ifInCorrect(oi) {
    if (this.question["正确答案"].indexOf(oi) !== -1) {
      return true;
    } else {
      return false;
    }
  }
}
